export default function remap(
  value,
  inputLowerBound,
  inputUpperBound,
  outputLowerBound = 0,
  outputUpperBound = 1,
  clamp = true,
) {
  let p = (value - inputLowerBound) / (inputUpperBound - inputLowerBound);
  if (clamp) {
    if (p < 0) p = 0;
    else if (p > 1) p = 1;
  }
  return outputLowerBound + (outputUpperBound - outputLowerBound) * p;
}
